import React from "react";
import { getTurkishPlural } from "../../utils/getTurkishPlural";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";

export default function SummaryChildLimitedDiscountContinue(props) {
  // PROPS COMING FROM SummaryBeforeAddToCart
  const { normalisedQty, price, product, /*validPrice,*/ cartSkuItemsLength } =
    props;

  return (
    <table
      style={{
        width: "95%",
        marginTop: "1rem",
        fontSize: "1rem",
      }}
    >
      <thead>
        <tr
          style={{
            backgroundColor: "lightgrey",
          }}
        >
          <th
            style={{
              border: "3px solid white",
              alignItems: "center",
            }}
            colSpan="5"
          >
            <p className="padq txtcenter">Sepet Öncesi Özet</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          style={{
            borderBottom: "3px solid white",
          }}
        >
          <th
            className="lh1-5"
            style={{
              border: "3px solid white",
            }}
            colSpan={4}
          >
            <p>
              İndirimsiz {normalisedQty} {product.productUnit}
            </p>
          </th>
          <td
            className="txtright"
            style={{
              border: "3px solid white",
              color: "red",
            }}
          >
            <strike className="red-col">
              {calculateDisplayedPrice(price.price, normalisedQty)}
            </strike>{" "}
            TL
          </td>
        </tr>
        {cartSkuItemsLength > 0 ? (
          <tr></tr>
        ) : (
          <tr
            style={{
              borderBottom: "3px solid white",
            }}
          >
            <th
              className="lh1-5"
              style={{
                border: "3px solid white",
              }}
              colSpan={4}
            >
              <p>İlk {product.productUnit} İndirimi</p>{" "}
            </th>
            <td
              className="txtright"
              style={{
                border: "3px solid white",
              }}
            >
              <p className="fs-85 bold-font green">
                -
                {calculateDisplayedPrice(
                  product.timeLimitedDiscount.discountAmount
                )}{" "}
                TL
              </p>
            </td>
          </tr>
        )}
        {normalisedQty > 1 ? (
          <tr
            style={{
              borderBottom: "3px solid white",
            }}
          >
            <th
              className="lh1-5"
              style={{
                border: "2px solid white",
              }}
              colSpan={4}
            >
              <p>Ek {getTurkishPlural(product.productUnit)} İndirimi</p>
              {/*<p>
                İndirimi{" "}
                <span className="fs-85 bold-font green">
                  -
                  {calculateDisplayedPrice(
                    price.price,
                    "",
                    price.priceGap,
                    "showDiscountAmount"
                  )}{" "}
                  TL
                </span>
                  </p>*/}
            </th>
            <td
              className="txtright"
              style={{
                border: "2px solid white",
              }}
            >
              <p className="green">
                -
                {calculateDisplayedPrice(
                  price.price,
                  normalisedQty - 1,
                  price.priceGap,
                  "showDiscountAmount"
                )}{" "}
                TL
              </p>
              {/*cartSkuItemsLength > 0
                ? calculateDisplayedPrice(price.priceGap, normalisedQty)
                : calculateDisplayedPrice(
                    "",
                    normalisedQty,
                    price.priceGap,
                    "",
                    "onlyPriceGapTotal"
                  )*/}{" "}
            </td>
          </tr>
        ) : (
          <tr>
            <td></td>
          </tr>
        )}
      </tbody>
      <tfoot>
        {/*<tr
          style={{
            borderBottom: "2px solid white",
          }}
        >
          <th colSpan={3} className="txtmid">
            <p className="txtmid">Toplam İndirim</p>
          </th>
          <td colSpan={2} className="green bold-font lh1-5 txtright">
            -
            {cartSkuItemsLength > 0
              ? calculateDisplayedPrice(
                  price.price,
                  normalisedQty,
                  price.priceGap,
                  "showDiscountAmount"
                )
              : calculateDisplayedPrice(
                  price.price,
                  normalisedQty,
                  price.priceGap,
                  "showDiscountAmount",
                  "",
                  product.timeLimitedDiscount.discountAmount,
                  "",
                  "",
                  "",
                  "cartIsEmpty"
                )}{" "}
            TL
          </td>
              </tr>*/}
        <tr
          style={{
            borderBottom: "3px solid white",
          }}
        >
          <th colSpan={3} className="txtmid">
            <p className="txtmid">Toplam Tutar</p>
          </th>
          <td colSpan={2} className="lh1-5 txtright">
            {cartSkuItemsLength > 0
              ? calculateDisplayedPrice(price.priceGap, normalisedQty)
              : calculateDisplayedPrice(
                  price.price,
                  normalisedQty,
                  price.priceGap,
                  "",
                  "",
                  product.timeLimitedDiscount.discountAmount,
                  "sum"
                )}{" "}
            TL
          </td>
        </tr>
        <tr
          style={{
            backgroundColor: "lightgrey",
          }}
        >
          <th
            style={{
              border: "3px solid white",
              alignItems: "center",
            }}
            colSpan="5"
          >
            <ul className="padq txtleft lh1-5">
              <li className="beddo-border-bottom-light">
                <i className="fas fa-square beddo-color fs-65 marq"></i>Tasarruf
                için adet artırın.
              </li>
              <li className="beddo-border-bottom-light">
                <i className="fas fa-square beddo-color fs-65 marq"></i>
                Sevdikleriniz için adet artırın.
              </li>
              <li className="beddo-border-bottom-light">
                <i className="fas fa-square beddo-color fs-65 marq"></i>Farklı
                mekanlar için adet artırın.(Ev, ofis, vb.)
              </li>
            </ul>
          </th>
        </tr>
      </tfoot>
    </table>
  );
}
